import React, { useEffect, useState } from 'react';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
// import Layout from '../common/Layout';
import ActionTable from '../common/Table';
import { CommonConfig } from '../../../config/common-config';
import token from '../../../config/token';
import SearchBox from '../../../components/table/SearchBox';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

const UltimateInvoice = () => {
    const tokens = token();
    const [searchQuery, setSearchQuery] = useState('');
    const [rows, setRows] = useState([]);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const createGenInfo = useSelector((state) => state.geninforeducer.creategeninfo);
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    console.log('tennantDetails', tennantDetails);

    const headcells = [
        { id: 'serviceId', label: 'Service ID' },
        { id: 'invoiceNumber', label: 'Invoice Number' },
        { id: 'invoiceDate', label: 'Invoice date' },
        // { id: 'description', label: ' Invoice Description' },
        { id: 'totalAmount', label: 'Amount' },
        { id: 'isPaid', label: 'Status' },
    ];

    // Set Rows
    const getDetailsOf = {
        buyerType: tennantDetails.typeReq === "CORPORATE" ? "Corporate" : "INDIVIDUAL",
        buyerEmail: tennantDetails.userName,
    };

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const clearField = () => {
        // if(searchQuery > 0){
        setSearchQuery('');
        // setSearchData([]);
        setPage(0);
        getInvoices();
        // }
    }

    const getInvoices = () => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        axios
            .post(
                `${CommonConfig.dev.baseUrl}/api/auth/admininvoices/list/${tennantDetails.tennantName}?page=${page}&size=10&sort=id,desc`,
                getDetailsOf,
                tokens
            )
            .then((response) => {
                setRows(response.data.content);
                console.log('=====', response.data);

                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => {
                //console.log(error);
            });
    };

    // const history = useHistory();
    useEffect(() => {
        if (tennantDetails.tennantName) {
            getInvoices();
        }
    }, [tokens]);

    // handle search item
    const handleSearchQuery = (data) => {
        //console.log(data);
        setSearchQuery(data);
    };

    // external css
    const classes = useStyles();

    // Filtered Row based on search
    const filteredRow = searchQuery
        ? rows.filter((row) => {
            const query = searchQuery.toLowerCase().trim();
            //   ////console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
            return headcells
                .map((col) => col.id)
                .some((key) => {
                    //console.log(row[key],"Value of ROW****row[key]");
                    //return row[key].toString().toLowerCase().includes(query);

                    if (row[key]) {
                        //   ////console.log('searchRow[key.id]',searchRow[key.id])
                        //   ////console.log('toString().toLowerCase()',searchRow[key.id].toString().toLowerCase())
                        return row[key].toString().toLowerCase().includes(query);
                    } else {
                        return false;
                    }
                });
        })
        : rows;

    return (
        <div className={classes.root}>
            <Card className="custom-table">
                <CardContent className="card-title-display">
                    <Grid item xs={12} sm={8}>
                        <Typography className="card-title">My Invoices</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} className="card-search">
                        <div className="search-field">
                            <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                        </div>
                    </Grid>
                </CardContent>
                <CardContent className="card-table-display">
                    {rows && filteredRow.length > 0 ? (
                        <>
                            <ActionTable
                                headcells={headcells}
                                rows={filteredRow}
                                action
                                post="itec"
                                mode="service"
                                handleCount={handleCount}
                                pageDetails={pageDetails}
                                loading={loading}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                            />
                        </>
                    ) : (
                            <div className={classes.noRecord}>
                                <h1>No records to display</h1>
                            </div>
                        )}
                </CardContent>
            </Card>
            {/* <Layout title="My Invoices" searchQuery={searchQuery} onChange={handleSearchQuery} className={classes}>
                {filteredRow.length === 0 && <span style={{ fontSize: '14px', fontWeight: '700' }}>No records found to display!</span>}
                <ActionTable headcells={headcells} rows={filteredRow} action post="itec" mode="service" />
            </Layout> */}
        </div>
    );
};

export default UltimateInvoice;
